import React, { useEffect, useState } from "react";
import Router, { useRouter } from "next/router";
import { useFormContext, useForm, FormProvider } from "react-hook-form";
import {
  Button,
  useSnackBar,
  Font,
} from "@moneyforward/mfx_biz_react_components";
import {
  KanaNameFormField,
  NameFormField,
  EmailFormField,
  PasswordFormField,
  TermsFormField,
} from "@/components/molecules";
import { passwordValidation } from "@/components/validations";
import { getErrorMessage, InternalServerErrorMessage } from "@/libs/errors";
import * as constants from "@/libs/constants";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { useIsSpMode } from "@/hooks";

type Props = {
  onSubmit?: (v: any) => void;
};

export const ConnectBoardRegisterUserForm = ({ onSubmit }: Props) => {
  const isSpMode = useIsSpMode();
  const { handleSubmit, formState } = useFormContext();

  const { notify } = useSnackBar();

  return (
    <div css={container}>
      <form onSubmit={handleSubmit(onSubmit)} css={form}>
        <div css={!isSpMode ? box : spModeBox}>
          <div css={!isSpMode ? inputList : spModeInputList}>
            <div css={listItem}>
              <NameFormField
                nameLastName="lastName"
                nameFirstName="firstName"
              />
            </div>
            <div css={listItem}>
              <KanaNameFormField
                nameLastName="lastNameKana"
                nameFirstName="firstNameKana"
              />
            </div>
          </div>
        </div>
        <div css={buttonWrapper}>
          <Button
            type="submit"
            variant="primary"
            disabled={formState.isSubmitting}
          >
            登録
          </Button>
        </div>
      </form>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  padding: "18px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const spModeBox = css({
  width: "100%",
  minHeight: "245px",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "640px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
  paddingTop: "8px",
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "15px",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginTop: "24px",
});

const labelWrapper = css({
  width: "640px",
  padding: "24px",
  backgroundColor: color.gray50,
  marginTop: "24px",
  borderRadius: "2px",
});
